module.exports = "<div class=\"dropdown\">\n\t<div class=\"dropdown-active\">{{ selected.value }}<svg class=\"icon-arrow-vertical color-muted\"><use xlink:href=\"#arrow-vertical\"></use></svg></div>\n\t<div class=\"dropdown-items\">\n\t\t<div class=\"dropdown-item\" ng-class=\"{ 'selected': item.value === selected }\" ng-click=\"select( item.key )\" ng-repeat=\"item in content\">{{ item.value }}</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/templates/bits/dropdown.html
// module id = 58
// module chunks = 0